<template>
  <div class="meau">
    <div class="content">
      <div class="logo show"><img src="../assets/logo.png" alt=""></div>
      <div class="logo hide"><img src="../assets/mobile_logo.png" alt=""></div>
      <div class="anchor">
        <!-- <p class="anchor_li">{{ $t('meau.nav1') }}</p>
          <p class="anchor_li">{{ $t('meau.nav2') }}</p>
          <p class="anchor_li">{{ $t('meau.nav3') }}</p>
          <p class="anchor_li">{{ $t('meau.nav4') }}</p>
          <p class="anchor_li">{{ $t('meau.nav5') }}</p> -->
        <el-anchor direction="horizontal" :offset="140">
          <el-anchor-link href="#deeplink">{{ $t('meau.nav1') }}</el-anchor-link>
          <el-anchor-link href="#buy">{{ $t('meau.nav2') }}</el-anchor-link>
          <el-anchor-link href=""><a class="anchor_li" href="https://www.deeplink.cloud/DeepLink_Whitepaper.pdf" target="_blank">{{ $t('meau.nav3') }}</a></el-anchor-link>
          <el-anchor-link href=""><a class="anchor_li" href="https://www.deeplink.cloud/DeepLinkResearch_En.pdf" target="_blank">{{ $t('meau.nav6') }}</a></el-anchor-link>
          <el-anchor-link href=""><a class="anchor_li" href="https://www.deeplink.cloud/DeepLink_Protocol.pdf" target="_blank">{{ $t('meau.nav4') }}</a></el-anchor-link>
          <el-anchor-link href="#faqs">{{ $t('meau.nav5') }}</el-anchor-link>
        </el-anchor>
      </div>
      <div class="link_wallet">
        <walletconnect></walletconnect>
        <!-- <div class="wallet_add">
          <span class="icon"></span>
          <p class="text">{{ $t('meau.add') }} 5F7L9bc3q4XdhVstJjVB2o7S8RHz2YKsHUB6k3uQpErTmVWu</p>
        </div>
        <div class="wallet_btn">{{ $t('meau.link') }}</div> -->
      </div>
      <div class="right-meau hide">
        <div class="nav2">
          <!-- <p>简体中文</p> -->
          <el-dropdown popper-class="demo-dropdown" @command="handleCommand">
            <img class="icon1" src="../assets/icon.png" alt="">
            <!-- <span class="el-dropdown-link">{{text}}</span> -->
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="en">ENGLISH</el-dropdown-item>
                <!-- <el-dropdown-item command="zh">简体中文</el-dropdown-item>
                <el-dropdown-item command="ko">한국어</el-dropdown-item> -->
                <el-dropdown-item command="ja">日本語</el-dropdown-item>
                <!-- <el-dropdown-item command="ru">Русский</el-dropdown-item>
                <el-dropdown-item command="vn">Việt nam</el-dropdown-item> -->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- <img class="icon2" src="../assets/arrow.png" alt=""> -->
        </div>
        <img class="mobile_meau" src="../assets/meau.png" alt="deeplink meau" @click="drawer = true">
      </div>
      <div class="nav2 show">
        <img class="icon1" src="../assets/icon.png" alt="">
        <!-- <p>简体中文</p> -->
        <el-dropdown popper-class="demo-dropdown" @command="handleCommand">
          <span class="el-dropdown-link">{{text}}</span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="en">ENGLISH</el-dropdown-item>
              <!-- <el-dropdown-item command="zh">简体中文</el-dropdown-item>
              <el-dropdown-item command="ko">한국어</el-dropdown-item> -->
              <el-dropdown-item command="ja">日本語</el-dropdown-item>
              <!-- <el-dropdown-item command="ru">Русский</el-dropdown-item>
              <el-dropdown-item command="vn">Việt nam</el-dropdown-item> -->
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <img class="icon2" src="../assets/arrow.png" alt="">
      </div>
    </div>
  </div>
  <el-drawer direction="ltr" class="drawer" v-model="drawer" :with-header="false">
    <div class="meaulist">
      <p class="meau_li" @click="scrollToAnchor('deeplink')">{{ $t('meau.nav1') }}</p>
      <p class="meau_li" @click="scrollToAnchor('buy')">{{ $t('meau.nav2') }}</p>
      <a href="https://www.deeplink.cloud/DeepLink_Whitepaper.pdf" target="_blank" class="meau_li">{{ $t('meau.nav3') }}</a>
      <a href="https://www.deeplink.cloud/DeepLinkResearch_En.pdf" target="_blank" class="meau_li">{{ $t('meau.nav6') }}</a>
      <a href="https://www.deeplink.cloud/DeepLink_Protocol.pdf" target="_blank" class="meau_li">{{ $t('meau.nav4') }}</a>
      <p class="meau_li" @click="scrollToAnchor('faqs')">{{ $t('meau.nav5') }}</p>
    </div>
  </el-drawer>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed, watch} from "vue";
  import { useI18n } from "vue-i18n";
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from "vuex"
  import walletconnect from "@/components/walletconnect.vue"
  export default defineComponent({
    name: 'PreSale',
    components: {
      walletconnect
    },
    setup() {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const text = ref('ENGLISH')
      const lanObj = {
        'en': 'ENGLISH',
        'ko': '한국어',
        'zh': '简体中文',
        'ja': '日本語',
        'ru': 'Русский',
        'vn': 'Việt nam'
      }
      const handleCommand = (command) => {
        text.value = lanObj[command]
        locale.value = command
        localStorage.setItem('lan', command)
        store.commit('changeLan', command)
      }
      const drawer = ref(false)

      const scrollToAnchor = (id) => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
        drawer.value = false
      }
      onMounted(() => {
        text.value = lanObj[lan.value]
      });
      watch(lan, (newValue) => {
        
      })
      return {
        lan,
        text,
        drawer,
        handleCommand,
        scrollToAnchor
      };
    }
  })
</script>

<style scoped lang="scss">
.meau {
  width: 100%;
  height: 72px;
  display: flex;
  // min-width: 1200px;
  font-style: normal;
  align-items: center;
  background: #110C29;
  .content {
    margin: auto;
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      width: 69px;
      height: 36px;
      img {
        width: 69px;
        height: 36px;
      }
    }
    .show {
      display: block;
    }
    .hide {
      display: none;
    }
    .link_wallet {
      display: flex;
      align-items: center;
      .wallet_add {
        width: 150px;
        display: flex;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        margin-right: 8px;
        letter-spacing: 0em;
        align-items: center;
        color: rgba(255, 255, 255, 0.6);
        .icon {
          width: 12px;
          height: 12px;
          margin-right: 4px;
          display: inline-block;
          background: url(../assets/i.png) no-repeat 100%/100%;
        }
        .text {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .wallet_btn {
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        font-weight: 500;
        padding: 6px 20px;
        letter-spacing: 0em;
        border-radius: 58px;
        background: linear-gradient(271.98deg, #2AB36A 4.13%, rgba(104, 204, 79, 0.8) 114.86%);
      }
    }
    .nav2 {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-weight: 500;
      color: #FFFFFF;
      &:hover {
        color: #FFFFFF;
      }
      .el-dropdown {
        font-weight: 500;
        color: #FFFFFF;
        margin: 0 5px;
      }
      .icon1 {
        width: 20px;
        height: 20px;
      }
      .icon2 {
        width: 10px;
        height: 6px;
      }
    }
  }
  .anchor_li {
    color:rgba(255, 255, 255, 0.6); 
    text-decoration: none;
    &:hover {
      color: #fff;
    }
  }
}


@media screen and (max-width: 1200px) {
  .meau {
    // min-width: 600px;
    height: 70px;
    padding: 0 50px;
    box-sizing: border-box;
    .content {
      .logo {
        width: 60px;
        height: 36px;
        img {
          width: 60px;
          height: 36px;
        }
      }
      .show {
        display: none;
      }
      .hide {
        display: flex;
      }
      .anchor {
        display: none;
      }
    }
    .right-meau {
      display: flex;
      align-items: center;
      .nav2 {
        .icon1 {
          width: 30px;
          height: 30px;
        }
        margin-right: 6px;
      }
      .mobile_meau {
        width: 35px;
        height: 35px;
        cursor: pointer;
      }
    }
  }

  .meaulist {
    width: 100%;
    display: flex;
    flex-direction: column;
    .meau_li {
      width: 100%;
      margin: 20px 0;
      cursor: pointer;
      font-size: 22px;
      text-align: left;
      font-weight: 500;
      letter-spacing: 0em;
      text-decoration: none;
      color: rgba(255, 255, 255, 0.6);
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>


<style>
  .anchor .el-anchor {
    display: flex;
    align-items: center;
    background: transparent !important;
  }
  .anchor .el-anchor .el-anchor__link {
    cursor: pointer;
    font-size: 16px;
    text-align: left;
    font-weight: 500;
    margin-right: 25px;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 0.6);
  }
  .anchor .el-anchor .el-anchor__link:last-child{
    margin-right: 0;
  }
  .anchor .el-anchor .el-anchor__link:hover{
    color: #fff;
  }

  .anchor .el-anchor .el-anchor__link.is-active {
    color: #fff;
  }
  .anchor .el-anchor__marker {
    background-color: #fff;
  }


  .drawer {
    width: 80% !important;
    background: rgb(1, 1, 20) !important;
  }
</style>